export default class Configs {
  static readonly isProd = false

  static readonly API_URL = Configs.isProd ?
    'https://api.pingapp.me'
    : 'https://api-dev.imdev.work';

}
